import styled from "styled-components";
import { Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { C3Text } from "../../../common/components/text/CustomText";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

const BackgroundWrapper = styled.div`
    background-image: url("${process.env.PUBLIC_URL}/images/image_background_auth.png");
    background-size: 100% 100%;
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
`;

const ModalContainer = styled.div`
    background-color: #ffffff;
    border-radius: 24px;
    box-shadow: 0 4px 12px ${Theme.color.black_015};
    width: ${({ width }) => width || "90%"};
    height: ${({ height }) => height || "auto"};
    max-width: ${({ maxWidth }) => maxWidth || "1100px"};
    max-height: ${({ maxHeight }) => maxHeight};
    position: relative;
    display: flex;
    flex-direction: column;
    padding: ${({ padding }) => padding || "20px 20px"};
    box-sizing: border-box;
    overflow-y: ${({ overflowY }) => overflowY || "auto"};
    overflow-x: ${({ overflowX }) => overflowX || "hidden"};
`;

const InlineScroll = styled.div`
    overflow-y: ${({ overflowY }) => overflowY || "auto"};
    min-height: ${({ $minHeight }) => $minHeight || "auto"};
`;

function WebAuthContentWrapper({
    children,
    contentPadding = "20px 20px",
    overflowY,
    overflowX,
    contentMaxHeight = "90vh",
    contentMinHeight,
    header,
    footer,
}) {
    return (
        <BackgroundWrapper>
            <Row padding={"18px 21px"}>
                <CustomIcon iconName={"logo"} size={"32px"} />
                <SizedBox width={"10px"} />
                <C3Text fontWeight={"800"} letterSpacing={"-0.02rem"} fontColor={Theme.color.white}>
                    {Translate("common.laundryCrew")} {Translate("role.admin")}
                </C3Text>
            </Row>
            <SizedBox width={"43.5%"} height={"90%"} justifyContent={"center"} alignItems={"center"}>
                <ModalContainer
                    width={"90%"}
                    padding={contentPadding}
                    maxWidth={"475px"}
                    overflowY={overflowY}
                    overflowX={overflowX}
                    maxHeight={contentMaxHeight}
                >
                    {header}
                    {header || footer ? (
                        <InlineScroll $minHeight={contentMinHeight}>{children}</InlineScroll>
                    ) : (
                        children
                    )}
                    {footer}
                </ModalContainer>
            </SizedBox>
        </BackgroundWrapper>
    );
}

export default WebAuthContentWrapper;
